import { QuestLog, QuestLogItem } from 'components/Docs/QuestLog';
import OSButton from 'components/OSButton';
import { CalloutBox } from 'components/Docs/CalloutBox';
import { ProductScreenshot } from 'components/ProductScreenshot';
import { ProductVideo } from 'components/ProductVideo';
import { IconRewindPlay, IconToggle, IconFlask, IconGraph } from '@posthog/icons';
import ExperimentInstallationPlatforms from "../../../../contents/docs/experiments/installation/_snippets/installation-platforms.tsx";
import * as React from 'react';
export default {
  QuestLog,
  QuestLogItem,
  OSButton,
  CalloutBox,
  ProductScreenshot,
  ProductVideo,
  IconRewindPlay,
  IconToggle,
  IconFlask,
  IconGraph,
  ExperimentInstallationPlatforms,
  React
};